<template>
  <div class="redeem">
    <!-- <LoginModal
      v-if="loginModalShow"
      @toggleLoginModal="toggleLoginModal"
      @toggleRegisterModal="toggleRegisterModal"
      :redirectPath="redirectPath"
    />
    <RegisterModal
      v-else-if="guestModalShow"
      @toggleLoginModal="toggleLoginModal"
      @toggleRegisterModal="toggleRegisterModal"
      :redirectPath="redirectPath"
    />
    <Navbar /> -->
    <RedeemForm class="redeem-form" @toggleLoginModal="toggleLoginModal" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"

// import Navbar from "@/components/gift/Navbar"
import RedeemForm from "../../components/gift/redeem/RedeemForm.vue"

export default {
  data: function () {
    return {
      redirectPath: "/redeem",
    }
  },
  components: {
    // LoginModal: () => import("@/components/auth/LoginModal"),
    // RegisterModal: () => import("@/components/auth/RegisterModal"),
    // Navbar,
    RedeemForm,
  },
  computed: {
    ...mapGetters("Store", ["loginModalShow", "guestModalShow"]),
  },
  methods: {
    ...mapMutations("Store", ["setLoginModalShow", "setGuestModalShow"]),
    // updateRedirectPath (path) {
    //   this.redirectPath = path
    // },
    toggleLoginModal () {
      this.setLoginModalShow(!this.loginModalShow)
    },
  // toggleRegisterModal () {
  //   this.setGuestModalShow(!this.guestModalShow)
  // },
  },
}
</script>

<style lang="scss" scoped>
.redeem {
  min-height: 100vh;
  background: #fff;
  // .redeem-form {
  //   margin-top: 5.5rem;
  // }
}
</style>



// WEBPACK FOOTER //
// src/pages/store/Redeem.vue